<template>
  <b-modal
    ref="modal_unsaved_changes"
    :ok-title="$t('yes')"
    :cancel-title="$t('no')"
    centered
    hide-header
    @ok="click_ok"
    @cancel="click_cancel"
  >
    <p class="my-4">
      {{ text_unsaved_changes }}
    </p>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmLeaveDialog',
  props: ['text_unsaved_changes'],
  data() {
    return {
      answer: function () {
        return false
      },
    }
  },
  methods: {
    popup_and_get_answer() {
      this.$refs.modal_unsaved_changes.show()
      let self = this
      return new Promise(function (answer, reject) {
        self.answer = answer
      })
    },
    click_ok() {
      this.$refs.modal_unsaved_changes.hide()
      this.answer(true)
    },
    click_cancel() {
      this.$refs.modal_unsaved_changes.hide()
      this.answer(false)
    },
  },
}
</script>
